import { ExportOutlined } from '@ant-design/icons';
const ExportList = (props) => {
    const { url } = props;
    return (<a href={url} target='_self' rel='noreferrer noopener nofollow'>
      <ExportOutlined /> <span>导出结果</span>
    </a>);
};
export default ExportList;
